import { Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import { Footer } from '../../components/footer';
import { injectTSDI } from '../../core/common/tsdi';
import { I18n } from '../../core/i18n';
import { SharedContractDissolutionStore } from '../shared-contract-dissolution-store';
import { BottomPaddedGridItemM, BottomPaddedGridItemS } from '../styles';
import { ContractWithdrawalPage } from './contract-withdrawal-page';
import { ContractWithdrawalStore } from './contract-withdrawal-store';
import { ManualWithdrawalSuccessPageContainer } from './withdrawal-success/manual-withdrawal-success-page-container';
import { WithdrawalSuccessPageContainer } from './withdrawal-success/withdrawal-success-page-container';

const CenterGrid = styled(Grid)`
    text-align: justify;
    padding: 0 10px 0 10px;
    margin-top: 50px;
`;

const StyledBottomPaddedGridItemM = styled(BottomPaddedGridItemM)`
    width: inherit;
`;

export interface ContractWithdrawalProps {
    tenant?: string | null;
}

export const ContractWithdrawal = observer(
    (_props: ContractWithdrawalProps) => {
        const { translate } = injectTSDI(I18n);
        const {
            withdrawContractRequest,
            withdrawContractManualRequest,
            withdrawContractManualForm
        } = injectTSDI(ContractWithdrawalStore);

        const { getStudioInfo, getStudio } = injectTSDI(
            SharedContractDissolutionStore
        );

        const selectedStudioName = getStudio(
            withdrawContractManualForm.wrappedField.studioId.value
        )?.studioPublicDto?.name;

        return (
            <>
                <CenterGrid
                    container
                    direction="column"
                    alignContent="space-around"
                    data-scan-target
                >
                    <StyledBottomPaddedGridItemM
                        item
                        xs={12}
                        sm={10}
                        md={8}
                        lg={7}
                        xl={5}
                    >
                        <Typography variant="h4" component="h1">
                            {translate('public.content.withdraw.contract')}
                        </Typography>
                    </StyledBottomPaddedGridItemM>
                    <BottomPaddedGridItemS
                        item
                        xs={12}
                        sm={10}
                        md={8}
                        lg={7}
                        xl={5}
                    >
                        {withdrawContractRequest.state !== 'fetched' &&
                        withdrawContractManualRequest.state !== 'fetched' ? (
                            <ContractWithdrawalPage data-scan-target />
                        ) : (
                            ''
                        )}
                    </BottomPaddedGridItemS>
                    {withdrawContractRequest.state &&
                        !withdrawContractManualRequest.state && (
                            <BottomPaddedGridItemM
                                item
                                xs={12}
                                sm={10}
                                md={8}
                                lg={7}
                                xl={5}
                            >
                                <WithdrawalSuccessPageContainer
                                    showOnlySuccess
                                />
                            </BottomPaddedGridItemM>
                        )}
                    {!withdrawContractRequest.state &&
                        withdrawContractManualRequest.state && (
                            <BottomPaddedGridItemM
                                item
                                xs={12}
                                sm={10}
                                md={8}
                                lg={7}
                                xl={5}
                            >
                                <ManualWithdrawalSuccessPageContainer />
                            </BottomPaddedGridItemM>
                        )}
                </CenterGrid>
                <Footer
                    legalLinks={getStudioInfo.result?.legalLinks ?? []}
                    studioName={selectedStudioName}
                />
            </>
        );
    }
);
